import { computed, Directive, inject, input } from '@angular/core';

import { InvoiceWorkflowDirective } from '@features/feature-workflow/directives/invoice-workflow.directive';

import { UserTasksService } from '@models/user-tasks';

import { MessagesConstants } from '@shared/constants/messages.constants';
import { EventType, GqlService, WorkflowStep } from '@shared/services/gql.service';
import { OverlayService } from '@shared/services/overlay.service';
import { AuthService } from '@shared/store/auth/auth.service';
import { EventQuery } from '@shared/store/event/event.query';
import { InvoiceModel } from '@shared/store/invoice/invoice.model';
import { InvoiceQuery } from '@shared/store/invoice/invoice.query';
import { InvoiceService } from '@shared/store/invoice/invoice.service';
import { MainQuery } from '@shared/store/main/main.query';
import { WorkflowQuery } from '@shared/store/workflow/workflow.query';

import { InvoicesPageService } from '../../invoices-page.service';
import { InvoiceFormComponent } from '../invoice-form.component';
import { InvoiceFormUtils } from '../invoice-form.utils';

@Directive({
  hostDirectives: [InvoiceWorkflowDirective],
  standalone: true,
})
export class InvoiceBannerButtonDirective {
  authService = inject(AuthService);
  eventQuery = inject(EventQuery);
  gqlService = inject(GqlService);
  invoiceCtx = inject(InvoiceWorkflowDirective);
  invoiceQuery = inject(InvoiceQuery);
  invoiceService = inject(InvoiceService);
  invoicesPageService = inject(InvoicesPageService);
  mainQuery = inject(MainQuery);
  overlayService = inject(OverlayService);
  userTaskService = inject(UserTasksService);
  workflowQuery = inject(WorkflowQuery);

  iCloseMonthsProcessing = this.eventQuery.selectProcessingEvent(EventType.CLOSE_TRIAL_MONTH);
  isInvoiceFinalized = this.workflowQuery.getLockStatusByWorkflowStepType(
    WorkflowStep.WF_STEP_MONTH_CLOSE_LOCK_INVOICES
  );

  buttonDisabled = computed(() => {
    return this.isInvoiceFinalized() || this.iCloseMonthsProcessing();
  });

  invoice = input.required<InvoiceModel>();

  isAccrualPeriodInClosedMonth = computed(() => {
    const trial = this.mainQuery.selectedTrial();
    const { currentOpenMonth } = this.mainQuery.mainState();
    const invoice = this.invoice();

    return InvoiceFormUtils.isAccrualPeriodInClosedMonth({ currentOpenMonth, invoice, trial });
  });

  invoiceFormComponent = input<InvoiceFormComponent>();

  dontHavePermission = MessagesConstants.DO_NOT_HAVE_PERMISSIONS_TO_ACTION;
  invoiceLockTooltip = this.invoiceCtx.invoiceLockTooltip;
}
